export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass - Transmissão de jogos da NBA ao vivo | NBA.com',
	seo_meta_desc_leaguepass: 'Veja jogos da NBA, ao vivo e sob demanda, com o NBA League Pass. Acesse sua conta aqui.',
	seo_meta_keywords_leaguepass: 'Vídeos da NBA, melhores momentos da NBA, Vídeos de basquete, melhores jogadas, enterradas, recursos',
	seo_meta_title_featured: 'Streaming de jogos e destaque da NBA | NBA.com',
	seo_meta_desc_featured: 'Assista a destaques, notícias e análises grátis da NBA, em vídeo e de graça. Além disso, explore as assinaturas da NBA TV e do League Pass para assistir a jogos ao vivo nos aparelhos de sua preferência.',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - Streaming de jogos ao vivo e cobertura 24 horas | NBA.com',
	seo_meta_desc_nbatv: 'Veja jogos da NBA TV ao vivo ou assista a partidas clássicas. Além disso, tenha acesso a programas de estúdio e análises de toda a liga.',
	seo_meta_keywords_nbatv: 'NBA TV Channel, o som, clássicos inesquecíveis, nba ao vivo, nba real, nba gametime, fantasy insider, programas de estúdio, o salto',
	seo_meta_title_classicgames: 'Streaming de jogos clássicos com a NBA TV e mais | NBA.com',
	seo_meta_desc_classicgames: 'Veja confrontos icônicos da NBA com a NBA TV. Além disso, assista a jogos da NBA TV ao vivo e obtenha acesso a programas de estúdio e análises de toda a liga.',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: 'Streaming de conteúdo aqui | NBA.com',
	seo_meta_title_videolist: 'Veja {0} aqui | NBA.com',
	seo_meta_desc_videolist: 'Assista a vídeos de {0} aqui. Além disso, explore as assinaturas da NBA TV e do League Pass para assistir a jogos ao vivo nos aparelhos de sua preferência.',
	seo_meta_title_videolist_show: 'Veja {0} com a NBA TV | NBA.com',
	seo_meta_desc_videolist_show: 'Assista a {0} aqui. Além disso, veja jogos da NBA TV ao vivo e obtenha acesso a jogos clássicos e análises.',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: 'Veja {0} aqui | NBA.com',
	seo_meta_desc_videolist_feed: 'Assista a vídeos de {0} aqui. Além disso, explore as assinaturas da NBA TV e do League Pass para assistir a jogos ao vivo nos aparelhos de sua preferência.',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'Veja programas de estúdio com a NBA TV e mais | NBA.com',
	seo_meta_desc_shows: 'Explore o streaming dos últimos episódios e programas da NBA TV sob demanda. Além disso, veja jogos da NBA TV ao vivo e obtenha acesso a jogos clássicos e análises.',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: 'Página Inicial | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'Canais | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'Canal | NBA.com',
	seo_meta_pre_title_categories: 'Categorias | NBA.com',
	seo_meta_title_categories: 'Categorias | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'Categoria | NBA.com',
	seo_meta_title_category: 'Categoria | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'Streaming de vídeo aqui | NBA.com',
	seo_meta_pre_title_event: 'Streaming de evento aqui | NBA.com',
	seo_meta_title_events: 'Eventos | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'Veja {0} aqui | NBA.com',
	seo_meta_desc_event: 'Assista a {0} aqui. Além disso, explore as assinaturas da NBA TV e do League Pass para assistir a jogos ao vivo nos aparelhos de sua preferência.',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'Busca | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'Página não encontrada | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'Streaming do jogo aqui | NBA.com',
	seo_meta_title_game: 'Streaming de {0} aqui | NBA.com',
	seo_meta_desc_game: 'Assista a {0} aqui. Além disso, explore as assinaturas da NBA TV e do League Pass para assistir a jogos ao vivo nos aparelhos de sua preferência.',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'Streaming de {0} aqui | NBA.com',
	seo_meta_desc_video: 'Assista a {0} aqui. Além disso, explore as assinaturas da NBA TV e do League Pass para assistir a jogos ao vivo nos aparelhos de sua preferência.',
	seo_meta_keywords_video: 'Vídeos da NBA, melhores momentos da NBA, Vídeos de basquete, melhores jogadas, enterradas, recursos',
	seo_meta_title_episode: 'Veja {0} com a NBA TV | NBA.com',
	seo_meta_desc_episode: 'Assista a {0} aqui. Além disso, veja jogos da NBA TV ao vivo e obtenha acesso a partidas clássicas e análises.',
	seo_meta_keywords_episode: 'Vídeos da NBA, melhores momentos da NBA, Vídeos de basquete, melhores jogadas, enterradas, recursos',
	seo_meta_title_channel: 'NBA TV ao vivo | NBA.com',
	seo_meta_desc_channel: 'O NBA TV Live é o canal de transmissão ao vivo 24 horas por dia do NBA TV, com partidas da NBA ao vivo e gravadas toda semana, programas de estúdio e análise de especialistas.',
	seo_meta_keywords_channel: 'NBA TV Channel, o som, clássicos inesquecíveis, nba ao vivo, nba real, nba gametime, fantasy insider, programas de estúdio, o salto',
	seo_meta_title_tvguide: 'Programação da transmissão ao vivo da NBA TV | NBA.com',
	seo_meta_desc_tvguide: 'Veja quando você pode fazer streaming de jogos da NBA TV ao vivo e programas de estúdio ao vivo com a NBA TV no seu aparelho favorito. Além disso, acesse programas de estúdio e análises sob demanda.',
	seo_meta_keywords_tvguide: 'NBA TV Channel, o som, clássicos inesquecíveis, nba ao vivo, nba real, nba gametime, fantasy insider, programas de estúdio, o salto',

	// Common
	timezone: 'BRT',
	default_feed_error_message: 'Algo deu errado, o conteúdo não está disponível no momento. Tente novamente.',
	watch_in_app: 'ASSISTIR NO APLICATIVO DA NBA',
	ad_blocked_message: 'Bloqueador de anúncios detectado: o conteúdo do NBA.com é patrocinado por publicidade. Para continuar aproveitando nosso conteúdo, desligue seu bloqueador de anúncios.',

	// Item
	no_content: 'Sem conteúdo',
	see_more: 'Ver mais',
	now_playing: 'Jogando agora',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Você atingiu o número máximo de vídeos favoritos. Remova alguns para poder adicionar mais.',
	item_live: 'Ao vivo',
	add_favourite_title: 'ADICIONAR AOS FAVORITOS',
	remove_favourite_title: 'REMOVER DOS FAVORITOS',
	// Channel: Schedule
	p_channel_live: 'Ao vivo',
	p_channel_schedule_title: 'Programação da NBA TV',
	p_channel_schedule_watch: 'Assistir',
	p_channel_live24x7_title: 'NBA TV 24 horas, 7 dias por semana',
	p_channel_live24x7_see_full_schedule: 'Veja a programação completa',
	p_channel_live24x7_up_next: 'A seguir',
	p_channel_live24x7_on_demand: 'NBA TV: sob demanda',
	p_channel_live24x7_collection: 'Coleção',
	p_channel_live24x7_demand_1_logo_text: 'programas originais',
	p_channel_live24x7_demand_1_show_name: 'Programas da NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'Programas de originais da NBA TV, incluindo Shaqtin \'a Fool, Beyond the Paint, Game Time e Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Jogos clássicos',
	p_channel_live24x7_demand_2_show_name: 'NBA | Jogos Clássicos',
	p_channel_live24x7_demand_2_show_desc: 'Assista a jogos clássicos completos, incluindo todas as Finais desde 2000, momentos históricos da liga e jogadores lendários',

	// Channel: Clips
	p_channel_error_msg: 'Ainda não está disponível',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Programação',

	// NBA TV Shows:
	p_nba_tv_shows: 'Programas da NBA TV',
	p_nba_tv_no_access_title: 'NBA 24 horas, 7 dias por semana: fique sempre por dentro com análises de jogos, análises de estúdio, programação original e muito mais!',
	p_nba_tv_no_access_desc: 'Assista a jogos ao vivo, além de programas e jogos clássicos sob demanda.',
	p_nba_tv_no_access_note: 'Zonas de exclusão se aplicam',

	// tv show item
	tv_show_item_latest_episode: 'último episódio',
	tv_show_item_no_latest_episode: 'nenhum episódio recente',
	see_all: 'Ver tudo',
	// header
	header_menu_watch: 'Assistir',
	header_menu_featured: 'DESTAQUE',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// search
	players: 'Jogadores',
	videos: 'Vídeos',
	teams: 'Equipes',
	most_searched: 'MAIS PROCURADOS',
	no_result: 'Sem dados',
	search_filter_type_most_relevant: 'Mais relevantes',
	search_filter_type_most_viewed: 'Mais vistos',
	search_filter_type_most_recent: 'Mais recentes',
	search_filter_type_last_30_days: 'Últimos 30 dias',
	search_filter_type_last_6_months: 'Últimos 6 meses',
	search_result_label: 'Resultados da busca por \'{keyword}\'',
	search_result_info: 'Exibir todos os resultados para {keyword}',
	search_placeholder: 'Buscar na videoteca',
	load_more: 'Carregar mais...',

	// button
	button_subscribe: 'Assine',
	button_sign_in: 'Entrar',
	button_tv_provider: 'Selecionar provedor de TV',

	// league page
	p_league_pass_no_access_title: 'Assista a jogos ao vivo ou em reprise em qualquer aparelho, incluindo computador, smartphone e TV!',
	p_league_pass_no_access_desc: 'Seu ingresso para a ação: assista a toda a liga ou seu time favorito, escolha um único jogo ou confira mais opções.',
	p_league_pass_no_access_note: 'Termos se aplicam',

	// Video
	category_title: 'Vídeo',
	p_video_playlist_title: 'Playlist',
	p_video_episode_text: 'Episódio',
	p_no_access_league_pass_title: 'Desbloqueie o NBA League Pass para assistir:',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: 'Seu ingresso para a ação: assista a toda a liga ou seu time favorito, escolha um único jogo ou confira mais opções.',
	p_no_access_league_pass_terms: 'Termos se aplicam',
	p_no_access_league_pass_geo_desc: 'Com base na sua localização atual, não é possível assistir a este jogo pelo NBA League Pass ou NBA TV. Estes jogos estarão arquivados e disponíveis para assinantes do NBA League Pass 3 dias após a transmissão. Consulte as programações das suas emissoras locais de TV e rádio para saber onde encontrar as transmissões na sua área.',
	p_no_access_league_pass_not_found_desc: 'Desculpe, o vídeo solicitado não foi encontrado.',
	p_no_access_event_geo_desc: 'Esta transmissão não está disponível para fãs nos Estados Unidos ou Canadá. Para assistir, sintonize a ESPN nos EUA e a TSN ou Sportsnet no Canadá.',
	p_no_access_event_not_found_desc: 'Desculpe, o evento solicitado não foi encontrado.',
	p_no_access_nba_tv_title: 'Desbloqueie a NBA TV para assistir:',
	p_no_access_nba_tv_desc: 'Assista a jogos ao vivo, além de programas e jogos clássicos sob demanda.',
	p_no_access_nba_tv_terms: 'Termos se aplicam',
	p_no_access_nba_tv_geo_desc: 'Com base na sua localização atual, não é possível assistir a este jogo pelo NBA League Pass ou NBA TV. Estes jogos estarão arquivados e disponíveis para assinantes do NBA League Pass 3 dias após a transmissão. Consulte as programações das suas emissoras locais de TV e rádio para saber onde encontrar as transmissões na sua área.',
	p_no_access_nba_tv_not_found_desc: 'Desculpe, o canal solicitado não foi encontrado.',
	p_no_access_up_next: 'A seguir',
	p_video_completed_title: 'Playlist completa',
	p_video_completed_desc: 'Volte para navegar ou confira a próxima playlist para você',
	p_video_share_to: 'Compartilhar em:',
	p_video_more_to_watch: 'Mais para assistir:',

	// Event
	p_event_section_title: 'EVENTO',
	p_event_playlist_title: 'Playlist:',
	p_event_button_watch: 'Assistir',
	p_event_button_listen: 'Ouvir',
	p_event_button_ticket: 'Ingresso',

	// notfound page
	notfound: 'Desculpe, a página solicitada não foi encontrada.',
	notfound_desc: 'Verifique se há erro no URL.<br/>Você também pode tentar usar a ferramenta de navegação ou de busca do site para encontrar o conteúdo que quer.',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Sua conta do NBA League Pass atingiu seu número máximo de streams. Toque em \'Continuar\' para voltar a assistir neste aparelho.',
	modal_pcm_custom: 'CONTINUAR',
	modal_pcm_close: 'Cancelar',
	modal_pcm_ok: 'Ok',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Este vídeo não pode ser reproduzido no seu aparelho. Clique <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>AQUI</a> para obter mais ajuda.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'Ok',
	modal_video_unsupported_ok: 'Ok',

	// FreeSample
	freesample_notice_time: 'Tempo restante',
	freesample_notice_title: 'Aproveite os {0} minutos de acesso',
	freesample_notice_desc: 'Assine um pacote completo do League Pass para continuar a ter acesso ao conteúdo após o fim dos {0} minutos.',
	freesample_notice_subscribe_button: 'Assine',
	freesample_notice_cancel_button: 'CANCELE A QUALQUER MOMENTO',
	freesample_popup_title: 'O ACESSO TERMINOU',
	freesample_popup_subtitle: 'Assine o League Pass para assistir a ainda mais conteúdo da NBA.',
	freesample_popup_link: 'Saiba mais',
	freesample_popup_get_minutes_button: 'RECEBER {0}  MINUTOS',

	// Video list
	reg_required_desc: 'Você precisa fazer login para ver este conteúdo',
	favorite_teams_title: 'Equipes favoritas',
	bookmarked_title: 'Salvo',
	watch_history_title: 'Continue assistindo',
	game_schedule_title: 'Calendário de jogos',
	recommended_title: 'Recomendado',
	season_text: 'Temporada',

	// profile page
	section_information_title: 'Minhas informações',
	section_information_desc: 'Atualizar seus dados pessoais',
	section_information_email: 'E-mail',
	section_information_email_update: 'Atualizar endereço de e-mail',
	section_information_password: 'Senha',
	section_information_password_update: 'Alterar senha',
	section_information_social: 'Conexões sociais',
	section_information_nosocial_message: 'Você não tem contas vinculadas.',
	section_information_firstname: 'Nome',
	section_information_lastname: 'Sobrenome',
	section_information_birth: 'Data de nascimento',
	section_information_country: 'País / Região',
	section_information_postalcode: 'CEP',
	section_information_edit: 'Editar',
	section_tv_provider_title: 'Meu provedor de TV',
	section_tv_provider_desc: 'Acesse jogos e transmissões ao vivo de seu provedor de TV.',
	section_tv_provider_faq: 'Perguntas frequentes sobre provedores de TV',
	section_tv_provider_sign_out: 'Sair',
	section_tv_provider_sign_in: 'Fazer login com provedor de TV',
	section_fantasy_title: 'Fantasy',
	section_fantasy_desc: 'Ver as informações da sua conta fantasy',
	section_fantasy_displayname: 'Nome de exibição',
	section_marketing_title: 'Preferências de e-mail',
	section_marketing_desc: 'Visualizar suas preferências de comunicações de marketing e de privacidade',
	section_marketing_newsletters: 'Boletins informativos',
	section_marketing_message: 'Mensagens e anúncios da NBA',
	section_marketing_newsletters_desc_1: 'Notícias da NBA entregues diariamente na sua caixa de entrada',
	section_marketing_newsletters_desc_2: 'NBA G League: notícias e destaques da liga secundária oficial da NBA',
	section_marketing_newsletters_desc_3: 'Jr. NBA: notícias e conteúdo da iniciativa de basquete juvenil da NBA',
	section_marketing_newsletters_desc_4: 'Os últimos recursos no aplicativo da NBA, além de atualizações e ofertas do League Pass',
	section_marketing_newsletters_desc_5: 'Ofertas especiais de ingressos, ofertas de parceiros, eventos e descontos em artigos da NBA',
	section_marketing_newsletters_desc_6: 'Notícias e conteúdo da NBA escolhidos a dedo e entregues semanalmente na sua caixa de entrada',
	section_marketing_newsletters_desc_7: 'Notícias e ofertas da WNBA e seus parceiros',
	section_marketing_personal_title: 'Meus dados pessoais',
	section_marketing_personal_desc: 'Usar meus dados pessoais para a NBA me enviar mensagens e anúncios sobre produtos e iniciativas da NBA e de dos parceiros da NBA.',
	section_marketing_update_button: 'Atualizar preferências de marketing',
	section_marketing_update_success: 'Suas preferências foram atualizadas.',
	section_ccpa_title: 'Não vendam meus dados pessoais',

	// profile edit modal
	email_modal_title: 'atualizar endereço de e-mail',
	email_modal_new_email_label: 'novo endereço de e-mail',
	email_modal_update: 'Atualizar',
	email_modal_cancel: 'Cancelar',
	password_modal_title: 'Alterar senha',
	password_modal_current_label: 'Senha atual:',
	password_modal_new_label: 'Nova senha:',
	password_modal_confirm_label: 'Confirmar senha',
	password_modal_update: 'Atualizar',
	password_modal_cancel: 'Cancelar',
	personal_modal_title: 'atualizar dados pessoais',
	personal_modal_email: 'E-mail',
	personal_modal_password: 'Senha',
	personal_modal_birth: 'Data de nascimento',
	personal_modal_social: 'Conexões sociais',
	personal_modal_firstname: 'Nome',
	personal_modal_lastname: 'Sobrenome',
	personal_modal_country: 'País / Região',
	personal_modal_postalcode: 'CEP',
	personal_modal_zipcode: 'Código postal',
	personal_modal_postalcode_invalid_message: 'Deve ser um código postal válido',
	personal_modal_zipcode_invalid_message: 'Deve ser um ZIP code válido',
	personal_modal_update: 'Atualizar',
	personal_modal_cancel: 'Cancelar',

	// payflow
	payflow_profile_name: 'Nome:',
	payflow_profile_email: 'E-mail',

	// account page
	header_menu_account_my_account: 'Minha conta',
	header_menu_account_manage_account: 'Gerenciar conta',
	header_menu_account_favorite_teams: 'Equipes favoritas',
	header_menu_account_favorite_players: 'Jogadores favoritos',
	header_menu_account_viewing_history: 'Histórico de visualizações',
};
